import React from "react";
import LegalLayout from "../../components/LegalLayout";

const sectionStyle = { marginBottom: 24 };
const h1Style = { fontSize: 28, fontWeight: 700, margin: "0 0 24px", color: "#0f172a" };
const h2Style = { fontSize: 18, fontWeight: 600, margin: "20px 0 10px", color: "#334155" };
const pStyle = { margin: "0 0 12px" };

export default function LegalCookies() {
	return (
		<LegalLayout title="Política de Cookies">
			<h1 style={h1Style}>Política de Cookies</h1>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Cookies técnicas</h2>
				<p style={pStyle}>
					Son necesarias para el funcionamiento del sitio (sesión, preferencias
					esenciales, seguridad). No requieren consentimiento previo.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Cookies analíticas</h2>
				<p style={pStyle}>
					Si utilizamos Google Analytics u otras herramientas de analítica web,
					se emplean para entender el uso del sitio (visitas, páginas vistas,
					origen). Requieren consentimiento previo; puedes aceptarlas o rechazarlas desde el banner de cookies.
				</p>
				<p style={pStyle}>
					Las cookies de terceros están sujetas a sus propias políticas de
					privacidad.
				</p>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Tabla de cookies utilizadas</h2>
				<p style={pStyle}>
					Resumen de las cookies que podemos utilizar en esta web:
				</p>
				<div style={{ overflowX: "auto", marginTop: 12 }}>
					<table
						style={{
							width: "100%",
							borderCollapse: "collapse",
							fontSize: 14,
							border: "1px solid #e2e8f0",
						}}
					>
						<thead>
							<tr style={{ backgroundColor: "#f8fafc" }}>
								<th style={{ padding: "10px 12px", textAlign: "left", borderBottom: "2px solid #e2e8f0" }}>Cookie / Identificador</th>
								<th style={{ padding: "10px 12px", textAlign: "left", borderBottom: "2px solid #e2e8f0" }}>Finalidad</th>
								<th style={{ padding: "10px 12px", textAlign: "left", borderBottom: "2px solid #e2e8f0" }}>Duración</th>
								<th style={{ padding: "10px 12px", textAlign: "left", borderBottom: "2px solid #e2e8f0" }}>¿Consentimiento?</th>
							</tr>
						</thead>
						<tbody>
							<tr style={{ borderBottom: "1px solid #e2e8f0" }}>
								<td style={{ padding: "10px 12px" }}>guia_cookie_consent</td>
								<td style={{ padding: "10px 12px" }}>Guardar tu preferencia de cookies (aceptar/rechazar analíticas)</td>
								<td style={{ padding: "10px 12px" }}>Persistente (localStorage)</td>
								<td style={{ padding: "10px 12px" }}>No (técnica de configuración)</td>
							</tr>
							<tr style={{ borderBottom: "1px solid #e2e8f0" }}>
								<td style={{ padding: "10px 12px" }}>Sesión / autenticación</td>
								<td style={{ padding: "10px 12px" }}>Mantener la sesión de usuario (login)</td>
								<td style={{ padding: "10px 12px" }}>Sesión o según proveedor</td>
								<td style={{ padding: "10px 12px" }}>No (técnica necesaria)</td>
							</tr>
							<tr style={{ borderBottom: "1px solid #e2e8f0" }}>
								<td style={{ padding: "10px 12px" }}>Google Analytics (_ga, _gid, etc.)</td>
								<td style={{ padding: "10px 12px" }}>Analítica web: visitas, uso del sitio</td>
								<td style={{ padding: "10px 12px" }}>Hasta 2 años (según cookie)</td>
								<td style={{ padding: "10px 12px" }}>Sí (solo si aceptas cookies analíticas)</td>
							</tr>
						</tbody>
					</table>
				</div>
			</section>

			<section style={sectionStyle}>
				<h2 style={h2Style}>Consentimiento configurable</h2>
				<p style={pStyle}>
					Puedes aceptar o rechazar cookies no esenciales mediante el panel o
					banner de cookies. Las preferencias se guardan para futuras visitas.
				</p>
				<p style={pStyle}>
					Puedes modificar la configuración en cualquier momento desde el mismo
					panel o desde la configuración de tu navegador.
				</p>
			</section>

			<section style={sectionStyle}>
				<p style={{ ...pStyle, fontSize: 14, color: "#64748b" }}>
					Si en el futuro se incorporan cookies concretas (publicidad, redes
					sociales, etc.), se actualizará esta política y se detallarán en esta
					página.
				</p>
				<p style={pStyle}>
					Para más información sobre el tratamiento de datos personales consulta
					nuestra Política de Privacidad.
				</p>
			</section>
			<p style={{ ...pStyle, fontSize: 14, color: "#64748b" }}>
				Última actualización: marzo 2026
			</p>
		</LegalLayout>
	);
}
